import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Welcome to a space ride! I'm`}</h2>
    <h2>{`Suchana Chakrabarti 👧`}</h2>
    <br />
    <h4>{`Working professional, Graduate in Computer Science and Engineering`}</h4>
    <br />
    <h4>{`Am passionate about AI , Blockchain, web development and`}</h4>
    <h4>{`technical content writing.`}</h4>
    <br />
    <h4>{`Always eager to explore, solve problems and be productive.`}</h4>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      